module.exports = __webpack_public_path__ + "img/1.12c7bf6e.jpg";